import { render, staticRenderFns } from "./gasClamp_saddleAnchor.vue?vue&type=template&id=6d713116&scoped=true"
import script from "./gasClamp_saddleAnchor.vue?vue&type=script&lang=js"
export * from "./gasClamp_saddleAnchor.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_saddleAnchor.vue?vue&type=style&index=0&id=6d713116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d713116",
  null
  
)

export default component.exports